import React, { useContext } from 'react'
import { T } from '../../../traks';
import { Avatar } from './Avatar';
import UsersContext from '../../../contexts/usersContext';

const HeaderRow = () => {
	return (<>
		<thead>
			<tr className="bg_light_grey">
				<th className="py-3 ps-4 txt_blue_1">
					<T>Screen Name</T>
				</th>
				<th className="py-3 txt_blue_1">
					<T>Email</T>
				</th>
				<th className="py-3 txt_blue_1">
					<T>Roles</T>
				</th>
				<th></th>
			</tr>
		</thead>
	</>)
};

const UserRow = ({ user, deleteUser, index }) => {
	const { setEditUser } = useContext(UsersContext)
	const { screen_name, email, roles, user_id } = user;
	return (
		<tr>
			<td className="py-4 ps-4 cursor_pointer" onClick={() => setEditUser(user)}>
				<div className="d-flex align-items-baseline">
					<span className="me-2"><Avatar screenName={screen_name} index={index} /></span>
					<span className="txt_blue fw_500">{screen_name}</span>
				</div>
			</td>
			<td className="py-4 txt_blue_1 align-middle cursor_pointer" onClick={() => setEditUser(user)}>
				{email}
			</td>
			<td className="py-4 txt_blue_1 align-middle cursor_pointer" onClick={() => setEditUser(user)}>
				<RolesBadges roles={roles} />
			</td>
			<td className="py-4 align-middle text-end pe-3 min_width_td">
				<div className="d-flex align-items-baseline me-3">
					<span
						className="cursor_pointer me-4 txt_blue_1"
						onClick={() => deleteUser(user_id)}
					>
						<img src="https://static.sibilus.eu/gfx/white-trash-0.svg" alt="trash_icon" />
					</span>
					<span
						className="cursor_pointer txt_blue_1"
						onClick={() => setEditUser(user)}
					>
						<img src="https://static.sibilus.eu/gfx/edit_icon-0.svg" alt="edit_icon" />
					</span>
				</div>
			</td>
		</tr>
	);
};

const RolesBadges = ({ roles }) => {
	return roles.sort().map((role, index) => {
		if (role === "company_administrator") {
			return <span className="me-2 rounded-5 px-3 py-1 blue_avatar" key={"rb" + index}><T>Admin</T></span>
		} else if (role === "internal_case_worker") {
			return <span className="me-2 rounded-5 px-3 py-1 green_avatar" key={"rb" + index}><T>Internal</T></span>
		} else if (role === "external_case_worker") {
			return <span className="me-2 rounded-5 px-3 py-1 red_avatar" key={"rb" + index}><T>External</T></span>
		} else {
			return <span key={"rb" + index}>{role}</span>
		}
	})
}

const UserFooter = ({ activeUsers }) => {
	return (
		<>
			<tr className="align-baseline">
				<td className="ps-4 py-4" colSpan={4}>
					<div className="d-flex near_white_grey fw_500">
						<T>
							Showing
						</T>
						{" " + activeUsers.length + " "}
						<T>out of</T>
						{" " + activeUsers.length + " "}
						<T>results</T>
					</div>
				</td>
			</tr>
		</>
	)
}

const ActiveUsers = ({ users, deleteUser }) => {
	return (<>
		<div className="py-5">
			<table className="table sibilus_border sborder_radius_6px">
				<HeaderRow />
				<tbody className="bg-white">
					{users["active_users"].map((user, index) =>
						<UserRow
							user={user}
							deleteUser={deleteUser}
							key={`${index}_userrow`}
							index={index}
						/>
					)}
					<UserFooter activeUsers={users.active_users} />
				</tbody>
			</table>
		</div>
	</>);
};

export { ActiveUsers }
